import {PrimaryButton, Modal, SecondaryButton} from 'components';
import React from 'react';
import {Constants} from '../../../helpers';
import {useNavigate} from 'react-router-dom';
import {bluePadlock} from '../../../assets/images/images';

function PermissionsModal({
  open,
  setOpen,
  title,
  route,
  body,
  buttonText,
  showCancelBtn = true,
}) {
  const navigate = useNavigate();
  const handleProceed = () => {
    navigate(route || Constants.PAGES_URL.PROFILED_RISK_TRANSACTIONS);
    setOpen(false);
  };

  return (
    <Modal
      show={open}
      onClose={() => showCancelBtn && setOpen(false)}
      modalTitle={title || 'Access Full Profile Details'}
      modalTitleIcon={<img src={bluePadlock} alt="icon" />}
      extraModalClasses="max-w-fit overflow-y-auto h-fit max-h-[95%] sm:max-h-full relative text-left"
      modalPosition="justify-center items-center"
      modalPadding="lg:pr-[26.46%] lg:pl-[41.38%] px-6 sm:pt-10"
      noBottomPadding
      borderRadius="rounded-lg"
      modalBg="bg-white"
      pointerEventsNone
      overlayBackground
    >
      <div className="p-4 px-6 w-[450px] ">
        {body || (
          <p className="text-body text-sm leading-6">
            Your current <b>Basic Plan</b> only gives you a summary of this
            profile. To see the complete profile, including detailed history,
            connections, and deep risk analysis, you need to move to a higher
            plan. Please upgrade to the
            <b> Growth, Premium, or Enterprise plan</b> to view this data.
          </p>
        )}
      </div>
      <div className="w-full px-6 py-[14px] bg-[#F9F9F9] border-[0.5px] flex gap-4 border-transparent border-t-[#EFEFEF]">
        {showCancelBtn && (
          <SecondaryButton
            buttonText="Cancel"
            className="w-full !h-10"
            onClick={() => setOpen(false)}
          />
        )}
        <PrimaryButton
          buttonText={buttonText || 'Upgrade to View Details'}
          className="w-full !h-10"
          onClick={handleProceed}
        />
      </div>
    </Modal>
  );
}

export default PermissionsModal;
